import { getArchivedArticles, getFeaturedArticles, sortArticlesByDateDesc } from './articles'
import articlesData from '../mocks/articles.json'

const sampleArticles = [
  { id: 1, title: 'Primero', date: '2024-11-01' },
  { id: 2, title: 'Segundo', date: '2025-05-28' },
  { id: 3, title: 'Tercero', date: '2023-06-15' },
  { id: 4, title: 'Cuarto', date: '2025-05-26' },
  { id: 5, title: 'Quinto', date: '2025-03-05' }
]

describe('article utilities', () => {
  test('sorts articles by date in descending order', () => {
    const sorted = sortArticlesByDateDesc(sampleArticles)

    expect(sorted.map((article) => article.id)).toEqual([2, 4, 5, 1, 3])
  })

  test('returns the latest three articles as featured', () => {
    const featured = getFeaturedArticles(sampleArticles)

    expect(featured).toHaveLength(3)
    expect(featured.map((article) => article.id)).toEqual([2, 4, 5])
  })

  test('returns the rest of the articles as archive items', () => {
    const archived = getArchivedArticles(sampleArticles)

    expect(archived.map((article) => article.id)).toEqual([1, 3])
  })

  test('includes the newest 2026 press articles', () => {
    const titles = articlesData.Articles.map((article) => article.title)

    expect(titles).toContain('28M: Día Internacional de la Salud Menstrual')
    expect(titles).toContain('El cuerpo menopáusico visibiliza el paso del tiempo')
    expect(new Date(articlesData.Articles[0].date).getTime()).toBeGreaterThanOrEqual(new Date('2026-05-27').getTime())
  })
})
